import React from 'react';

interface Props {
    initCall: () => void;
    primaryText: string;
    secondaryText: string;
    transferOptionIcon: React.ReactNode;
    componentId: string;
    testId: string;
}

const TransferOptionRow = ({
    initCall,
    primaryText,
    secondaryText,
    transferOptionIcon,
    componentId,
    testId,
}: Props) => {
    return (
        <button
            onClick={initCall}
            key={componentId}
            className="hover:darken-10 relative box-border flex w-full cursor-pointer items-center justify-start gap-2 px-2 py-4 no-underline"
            data-test-id={testId}
        >
            {transferOptionIcon}
            <div className="flex flex-col items-start">
                <div className="text-sm font-bold">{primaryText}</div>
                <p className="text-sm text-gray-600">{secondaryText}</p>
            </div>
        </button>
    );
};

export default React.memo(TransferOptionRow);
